import { render, staticRenderFns } from "./LabsChoice.vue?vue&type=template&id=2721a9df&"
import script from "./LabsChoice.vue?vue&type=script&lang=js&"
export * from "./LabsChoice.vue?vue&type=script&lang=js&"
import style0 from "./LabsChoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports